/* LWL — Kombin Atölyesi motoru (ürün sayfası önerileri için)
   Puanlama/seçim kodu sections/lwl-kombin-atolyesi.liquid içinden birebir alınmıştır (2026-10-13).
   Atölyede algoritma değişirse bu dosya da aynı bölümden yeniden üretilmelidir. */
(function () {
	'use strict';
	if (window.LWLKombin) return;
	function build(json) {
		var root = { dataset: { style: 'smart' } };
		function $() { return { textContent: json }; }
		function trl(s) { return String(s || '').toLocaleLowerCase('tr'); }
		function uniq(a) { var o = []; a.forEach(function (x) { if (o.indexOf(x) < 0) o.push(x); }); return o; }
		function render() {}
		/* ---------- tarzlar ve tonlar ---------- */
		var STYLES = [
			{ k: 'smart', label: 'Smart Casual', d: 'Ceket, gömlek, chino', r: { dis: /süet|kaban|parka|bomber/, ust: /kadife gömlek|modal|tencel|çizgili|keten|crinkle|müslin|selanik|fermuarlı triko|baklava/, ic: /triko tişört/, alt: /chino|kadife pantolon|smart jogger|slim denim/ }, ic: 0.4, kolye: 0.3, dis: 1 },
			{ k: 'oldmoney', label: 'Old Money', d: 'Triko, kaban, kumaş', r: { dis: /kaban|süet/, ust: /selanik|baklava|triko kazak|fermuarlı triko|hırka/, ic: /tencel|modal|müslin|crinkle|keten|kadife gömlek|çizgili/, alt: /chino|pilili|kadife pantolon/ }, ic: 0.85, kolye: 0.15, dis: 1 },
			{ k: 'street', label: 'Sokak Stili', d: 'Sweatshirt, jean, rahat', r: { dis: /rüzgarlık|teddy|parka|süet|bomber/, ust: /hoodie|sweatshirt|oversize tişört/, ic: /triko tişört|oversize tişört/, alt: /baggy|jogger|eşofman|denim/ }, ic: 0.25, kolye: 0.6, dis: 0.85 },
			{ k: 'night', label: 'Akşam Şıklığı', d: 'Koyu ton, kadife, deri', r: { dis: /deri parka|kaban|bomber/, ust: /kadife gömlek|efektli|tencel|modal|fermuarlı triko/, ic: /triko tişört/, alt: /kadife pantolon|chino|slim denim|bol paça/ }, ic: 0.2, kolye: 0.5, dis: 1 },
			{ k: 'all', label: 'Serbest', d: 'Tüm parçalar', r: {}, ic: 0.35, kolye: 0.35, dis: 0.8 }
		];
		var TONES = [
			{ k: 'toprak', label: 'Toprak', sw: '#8a5a2b' },
			{ k: 'siyah', label: 'Siyah & Antrasit', sw: '#232323' },
			{ k: 'gri', label: 'Gri', sw: '#9a9a9a' },
			{ k: 'yesil', label: 'Haki & Yeşil', sw: '#5d6a33' },
			{ k: 'mavi', label: 'Lacivert & Mavi', sw: '#2c3e66' },
			{ k: 'acik', label: 'Açık Tonlar', sw: '#ece3d2' }
		];
		function toneOf(name) {
			var l = trl(name);
			if (/bej melanj|ekru|krem|beyaz|taş\b|taş$/.test(l)) return 'acik';
			if (/siyah|antrasit|füme|oniks/.test(l)) return 'siyah';
			if (/vizon/.test(l)) return 'toprak';
			if (/haki|yeşil|zümrüt|petrol|çağla|mint/.test(l)) return 'yesil';
			if (/lacivert|mavi|indigo|turkuaz/.test(l)) return 'mavi';
			if (/gri|melanj|gümüş|silver/.test(l)) return 'gri';
			if (/bej|kahve|tarçın|camel|toprak|taba|bordo|gold|hardal|pembe|kaplan/.test(l)) return 'toprak';
			return 'notr';
		}
		function isNeutral(tone, p) {
			return tone === 'siyah' || tone === 'gri' || tone === 'acik' || tone === 'notr' || (tone === 'mavi' && /denim|jean/.test(p.text));
		}

		/* ---------- ürün havuzu ---------- */
		function kindOf(d) {
			var y = trl(d.y), t = trl(d.t + ' ' + d.s);
			if (/dış giyim/.test(y)) return 'dis';
			if (/bileklik/.test(y)) return 'bileklik';
			if (/kolye/.test(y)) return 'kolye';
			if (/pantolon|şort/.test(y) || /pantolon|jean|jogger|eşofman altı|denim/.test(t)) return 'alt';
			if (/tişört|atlet/.test(y)) return 'tisort';
			if (/gömlek/.test(y)) return 'gomlek';
			if (/sweatshirt|kazak|hırka/.test(y)) {
				if (/hırka/.test(t)) return 'hirka';
				if (/sweatshirt|hoodie/.test(t)) return 'sweat';
				return 'triko';
			}
			if (/gömlek/.test(t)) return 'gomlek';
			if (/ceket|mont|kaban|parka/.test(t)) return 'dis';
			return null;
		}
		/* ---------- sezon: ürünün "Sezon" alanı (custom.sezon: Yaz / Kış / 4 Mevsim) doluysa oradan, boşsa addan ---------- */
		var MONTH = new Date().getMonth() + 1;
		var SEASON = (MONTH >= 5 && MONTH <= 9) ? 'yaz' : ((MONTH === 12 || MONTH <= 2) ? 'kis' : 'gecis');
		function seasonOf(se, kind, text) {
			var o = trl(se || '').trim();
			if (/yaz/.test(o) && !/sonbahar|kış|kis/.test(o)) return 'yaz';
			if (/kış|kis/.test(o) && !/yaz/.test(o)) return 'kis';
			if (/mevsim|dört|dort|sonbahar/.test(o)) return 'dort';
			if (/ilkbahar/.test(o)) return 'yaz';
			if (/kısa kol|şort|keten|müslin|yazlık|atlet|tank top|palmiye|crinkle/.test(text)) return 'yaz';
			if (kind === 'dis' || /kadife|şardon|kazak|hırka|kaban|mont|parka|süet|teddy|selanik|kaşe|bomber|kışlık|sweatshirt|hoodie/.test(text)) return 'kis';
			return 'dort';
		}
		/* ürünün "Kombin tarzı" alanı doluysa tarz eşleşmesi oradan, boşsa ürün adındaki kelimelerden */
		function styleKeys(ks) {
			var arr = Array.isArray(ks) ? ks : (ks ? String(ks).split(',') : []);
			var out = [];
			arr.forEach(function (x) {
				var n = trl(String(x)).trim();
				STYLES.forEach(function (s) { if (s.k !== 'all' && (trl(s.label) === n || s.k === n) && out.indexOf(s.k) < 0) out.push(s.k); });
			});
			return out;
		}
		function fits(re, p, sk) {
			if (p.st && p.st.length) return p.st.indexOf(sk || state.style) > -1;
			return re.test(p.text);
		}
		var DATA = [];
		try { DATA = JSON.parse($('.js-ka-data').textContent || '[]'); } catch (e) { DATA = []; }
		var P = [];
		DATA.forEach(function (d) {
			var kind = kindOf(d);
			if (!kind || !d.v || !d.v.length) return;
			var im = {}, star = d.im && d.im['*'];
			Object.keys(d.im || {}).forEach(function (k) { im[trl(k).trim()] = d.im[k]; });
			var p = { h: d.h, t: d.t, s: d.s || d.t, u: d.u, kind: kind, gh: !!d.gh, v: d.v, text: trl(d.s + ' ' + d.t), st: styleKeys(d.ks) };
			p.se = seasonOf(d.se, kind, p.text);
			p.colors = uniq(d.v.map(function (v) { return v[1]; })).map(function (c) {
				var src = im[trl(c).trim()] || star;
				return src ? { name: c, img: src, tone: toneOf(c || d.t), avail: d.v.some(function (v) { return v[1] === c && v[5]; }) } : null;
			}).filter(function (c) { return c && c.avail; });
			p.sizes = uniq(d.v.map(function (v) { return v[2]; })).filter(Boolean);
			if (p.colors.length) P.push(p);
		});
		var PH = {};
		P.forEach(function (p) { PH[p.h] = p; });
		function colorObj(p, name) { for (var i = 0; i < p.colors.length; i++) if (p.colors[i].name === name) return p.colors[i]; return p.colors[0]; }
		function sizesFor(p, color) {
			return p.sizes.map(function (sz) {
				var v = p.v.filter(function (x) { return x[1] === color && x[2] === sz; })[0];
				return { s: sz, ok: !!(v && v[5]) };
			}).filter(function (x) { return p.v.some(function (v) { return v[1] === color && v[2] === x.s; }); });
		}
		function variantOf(p, color, size) {
			var vs = p.v.filter(function (v) { return v[1] === color && (!size || !p.sizes.length || v[2] === size); });
			return vs.filter(function (v) { return v[5]; })[0] || vs[0] || null;
		}
		function needsSize(p) { return p.sizes.length > 1; }

		/* ---------- yuvalar ---------- */
		var SLOTS = [
			{ k: 'dis', label: 'Dış Giyim', kinds: ['dis'], opt: true, add: 'Dış giyim ekle' },
			{ k: 'ust', label: 'Üst', kinds: ['gomlek', 'triko', 'sweat', 'hirka', 'tisort'] },
			{ k: 'ic', label: 'İç Katman', kinds: ['tisort', 'gomlek'], opt: true, add: 'İçine tişört / gömlek ekle' },
			{ k: 'alt', label: 'Pantolon', kinds: ['alt'] },
			{ k: 'bileklik', label: 'Bileklik', kinds: ['bileklik'], opt: true, mini: true, add: 'Bileklik ekle' },
			{ k: 'kolye', label: 'Kolye', kinds: ['kolye'], opt: true, mini: true, add: 'Kolye ekle' },
			{ k: 'ekstra', label: '2. Seçenek', kinds: ['gomlek', 'triko', 'sweat', 'hirka', 'tisort', 'alt'], opt: true, extra: true, add: '2. parça ekle' }
		];
		var SK = {};
		SLOTS.forEach(function (s) { SK[s.k] = s; });
		var MAJOR = ['dis', 'ust', 'ic', 'alt', 'ekstra'];

		var state = { style: root.dataset.style || 'smart', tones: [], board: {}, locks: {}, showExtra: false };
		if (!STYLES.some(function (s) { return s.k === state.style; })) state.style = 'smart';
		function styleObj() { for (var i = 0; i < STYLES.length; i++) if (STYLES[i].k === state.style) return STYLES[i]; return STYLES[0]; }

		/* ic katman uyumu: gömlek altına tişört, triko/sweat/hırka altına gömlek ya da tişört */
		function icAllowed(kind) {
			var u = state.board.ust && PH[state.board.ust.h];
			if (!u) return true;
			if (u.kind === 'tisort') return false;
			if (u.kind === 'gomlek') return kind === 'tisort';
			return true;
		}
		function slotRegex(sl, p) {
			var r = styleObj().r;
			if (sl.k === 'ekstra') return p.kind === 'alt' ? r.alt : r.ust;
			return r[sl.k];
		}
		function inBoard(h, except) {
			return Object.keys(state.board).some(function (k) { return k !== except && state.board[k] && state.board[k].h === h; });
		}
		function candidates(sl) {
			return P.filter(function (p) {
				if (sl.kinds.indexOf(p.kind) < 0) return false;
				if (sl.k === 'ic' && !icAllowed(p.kind)) return false;
				return true;
			});
		}
		function toneScore(sl, p, c) {
			if (!state.tones.length) return 0;
			if (state.tones.indexOf(c.tone) > -1) return 2.4;
			var soft = sl.mini || sl.k === 'alt' || sl.k === 'ic';
			if (isNeutral(c.tone, p)) return soft ? 1.1 : 0.2;
			return soft ? -0.6 : -1.6;
		}
		/* renk bilgisi: açıklık (1 koyu – 6 açık), canlı renk, kahve, siyah, desen, kadife */
		function cinfo(name, p) {
			var l = trl(name || p.t);
			var L = /beyaz|ekru|krem/.test(l) ? 6 : /bej|taş/.test(l) ? 5 : /gri|vizon|camel|toprak|tarçın|hardal|pembe|turkuaz/.test(l) ? 4 : /siyah|oniks/.test(l) ? 1 : /antrasit|füme|lacivert|acı kahve|bordo|zümrüt|petrol/.test(l) ? 2 : 3;
			return {
				L: L,
				acc: /pembe|turkuaz|zümrüt|yeşil|bordo|hardal|petrol|mint|kırmızı/.test(l),
				brown: /kahve|camel|tarçın|toprak|taba/.test(l),
				black: /siyah/.test(l),
				pat: /çizgili|baklava|efektli|desenli|palmiye|kaplan/.test(l + ' ' + p.text),
				kad: /kadife/.test(p.text)
			};
		}
		function metalOf(c, p) {
			var l = trl(c.name);
			if (/gold|altın/.test(l)) return 'g';
			if (/gümüş|silver/.test(l)) return 's';
			var g = /gold|altın/.test(p.text), sv = /gümüş|silver/.test(p.text);
			if (g && !sv) return 'g';
			if (sv && !g) return 's';
			return '';
		}
		/* sezon: mevsim dışı parça ve "kaban altına yazlık gömlek" gibi uyumsuzluklar */
		function seasonScore(sl, p) {
			if (sl.mini) return 0;
			if (SEASON === 'yaz') return p.se === 'kis' ? -6 : 0;
			var sc = 0;
			if (p.se === 'yaz') sc = sl.k === 'ic' ? (SEASON === 'kis' ? -3 : -0.6) : (SEASON === 'kis' ? -6 : -2.8);
			if (sl.k === 'dis') {
				var u = state.board.ust && PH[state.board.ust.h];
				if (u && u.se === 'yaz') sc -= 4;
			}
			if ((sl.k === 'ust' || sl.k === 'ekstra') && state.board.dis && p.se === 'yaz') sc -= 3;
			return sc;
		}
		/* sezonun ürünü mü (yeni stok gelebilir: "son adet" notu ve beden cezası yalnızca sezon dışı ürünlerde) */
		function inSeason(p) { return SEASON === 'yaz' ? p.se === 'yaz' : p.se === 'kis'; }
		/* beden ve stok: müşterinin bedeni biliniyorsa yalnızca o bedende stoğu olanlar; bilinmiyorsa beden yelpazesi dolu olanlar öne */
		function stockScore(p, c) {
			if (!needsSize(p)) return 0;
			var vs = p.v.filter(function (v) { return v[1] === c.name; });
			var want = lastSize[sizeGroup(p)];
			if (want && vs.some(function (v) { return v[2] === want; })) {
				var w = vs.filter(function (v) { return v[2] === want; })[0];
				if (!w[5]) return -8;
				return (w[6] > 0 && w[6] <= 2 && !inSeason(p)) ? 0.8 : 0.3;
			}
			var sz = sizesFor(p, c.name), ok = sz.filter(function (x) { return x.ok; }).length;
			var ratio = sz.length ? ok / sz.length : 1;
			var qty = vs.reduce(function (a, v) { return a + (v[5] ? Math.min(v[6] || 0, 60) : 0); }, 0);
			return (inSeason(p) ? 0 : (ratio < 0.5 ? -1.6 : (ratio < 0.75 ? -0.5 : 0))) + (qty >= 30 ? 0.6 : 0);
		}
		/* renk uyumu: en fazla 1 canlı renk, tek desen, üst–alt arasında açık/koyu farkı, aynı renk tekrarı yok, takılarda aynı metal */
		function harmony(sl, p, c) {
			if (sl.mini) {
				var other = state.board[sl.k === 'kolye' ? 'bileklik' : 'kolye'];
				if (!other || !PH[other.h]) return 0;
				var m = metalOf(c, p), mo = metalOf(colorObj(PH[other.h], other.c), PH[other.h]);
				return (m && mo) ? (m === mo ? 1.5 : -2.5) : 0;
			}
			var mono = state.tones.length === 1, me = cinfo(c.name, p), sc = 0;
			MAJOR.forEach(function (k) {
				var b = state.board[k];
				if (!b || k === sl.k) return;
				var bp = PH[b.h];
				if (!bp) return;
				var isPair = (sl.k === 'alt') !== (k === 'alt');
				if ((sl.k === 'ekstra' || k === 'ekstra') && !isPair) return;
				var o = cinfo(b.c, bp);
				if (b.c && b.c === c.name && !mono && !(me.black && state.style === 'night')) sc -= 1.4;
				if (me.acc && o.acc && !mono) sc -= 2.5;
				if (me.pat && o.pat) sc -= 3;
				if (isPair) {
					var d = Math.abs(me.L - o.L);
					sc += d >= 2 ? 0.9 : ((d === 0 && !mono) ? -0.9 : 0);
					if ((me.brown && o.black) || (me.black && o.brown)) sc -= 0.8;
					if (me.kad && o.kad) sc -= b.c !== c.name ? 2.4 : 0.8;
				}
			});
			return sc;
		}
		function score(sl, p, c) {
			var sc = Math.random() * 0.4 + toneScore(sl, p, c) + (p.gh ? 0.6 : -0.4);
			if (!state.tones.length && /pembe|turkuaz|bebe mavisi/.test(trl(c.name))) sc -= 0.9;
			var re = slotRegex(sl, p);
			if (re) sc += fits(re, p) ? 1.6 : -2.2;
			if (inBoard(p.h, sl.k)) {
				var same = Object.keys(state.board).some(function (k) { return k !== sl.k && state.board[k] && state.board[k].h === p.h && state.board[k].c === c.name; });
				sc -= same ? 20 : (sl.k === 'ekstra' ? 0.2 : 6);
			}
			return sc + seasonScore(sl, p) + stockScore(p, c) + harmony(sl, p, c);
		}
		/* en iyi birkaç aday arasından seç: çeşitlilik korunur, uyumsuz sonuç çıkmaz */
		function pickFor(sl) {
			var all = [];
			candidates(sl).forEach(function (p) {
				p.colors.forEach(function (c) { all.push({ p: p, c: c, sc: score(sl, p, c) }); });
			});
			if (!all.length) return null;
			all.sort(function (a, b) { return b.sc - a.sc; });
			/* her üründen yalnızca en iyi rengi: çok renkli ürünler listeyi doldurmasın */
			var seenP = {};
			all = all.filter(function (x) { if (seenP[x.p.h]) return false; seenP[x.p.h] = 1; return true; });
			var top = all.filter(function (x, i) { return i < 6 && x.sc >= all[0].sc - 2; });
			var w = [0.3, 0.22, 0.17, 0.13, 0.1, 0.08].slice(0, top.length), tot = w.reduce(function (a, b) { return a + b; }, 0);
			var r = Math.random() * tot, i = 0;
			while (i < top.length - 1 && r > w[i]) { r -= w[i]; i++; }
			return { h: top[i].p.h, c: top[i].c.name, z: '' };
		}
		function keepSize(slot, pick) {
			var prev = state.board[slot];
			if (!pick) return pick;
			var p = PH[pick.h];
			var want = (prev && prev.z) || lastSize[sizeGroup(p)];
			if (want && sizesFor(p, pick.c).some(function (x) { return x.s === want && x.ok; })) pick.z = want;
			else if (!needsSize(p) && p.sizes.length === 1) pick.z = p.sizes[0];
			return pick;
		}
		var SIZE_KEY = 'lwlKaSize';
		var lastSize = {};
		try { lastSize = JSON.parse(localStorage.getItem(SIZE_KEY) || '{}') || {}; } catch (e) { lastSize = {}; }
		function saveSize() { try { localStorage.setItem(SIZE_KEY, JSON.stringify(lastSize)); } catch (e) {} }
		function sizeGroup(p) { return p.kind === 'alt' ? 'alt' : 'ust'; }

		/* düğmeli/örgü hırkanın altına mutlaka bir iç katman */
		function needIc() {
			var u = state.board.ust && PH[state.board.ust.h];
			return !!(u && u.kind === 'hirka' && !/fermuar/.test(u.text));
		}
		function generate() {
			var st = styleObj();
			var order = ['ust', 'alt', 'dis', 'ic', 'bileklik', 'kolye', 'ekstra'];
			var next = {};
			order.forEach(function (k) { if (state.locks[k] && state.board[k]) next[k] = state.board[k]; });
			var old = state.board;
			state.board = next;
			order.forEach(function (k) {
				if (next[k] || state.locks[k]) return;
				var sl = SK[k];
				if (k === 'ekstra') { if (old.ekstra && state.showExtra) state.board.ekstra = keepSize(k, pickFor(sl)); return; }
				if (k === 'dis' && (SEASON === 'yaz' || Math.random() > st.dis)) return;
				if (k === 'ic' && !needIc() && Math.random() > st.ic) return;
				if (k === 'kolye' && Math.random() > st.kolye) return;
				if (k === 'bileklik' && Math.random() > 0.9) return;
				var pk = pickFor(sl);
				if (pk) state.board[k] = keepSize(k, pk);
			});
			if (!state.board.ekstra) state.showExtra = false;
			render(true);
		}


		var seedPick = null;
		var KIND_SLOT = { dis: 'dis', gomlek: 'ust', triko: 'ust', sweat: 'ust', hirka: 'ust', tisort: 'ust', alt: 'alt', bileklik: 'bileklik', kolye: 'kolye' };
		function applySeed() {
			var p = PH[seedPick.h], slot = KIND_SLOT[p.kind] || 'ust';
			var fit = STYLES.filter(function (st) { return st.k !== 'all' && st.r[slot] && st.r[slot].test(p.text); });
			if (fit.length && !fit.some(function (st) { return st.k === state.style; })) state.style = fit[0].k;
			if (!fit.length && (slot === 'ust' || slot === 'alt' || slot === 'dis')) state.style = 'all';
			state.board = {};
			state.board[slot] = { h: p.h, c: seedPick.c, z: '' };
			state.locks = {};
			state.locks[slot] = true;
		}



		function look(h, c) {
			if (!PH[h]) return null;
			seedPick = { h: h, c: colorObj(PH[h], c).name };
			state.style = 'smart'; state.tones = []; state.board = {}; state.locks = {}; state.showExtra = false;
			applySeed();
			generate();
			return { style: state.style, board: JSON.parse(JSON.stringify(state.board)) };
		}
		return { P: P, PH: PH, SK: SK, SLOTS: SLOTS, look: look, colorObj: colorObj, variantOf: variantOf };
	}
	var KEY = 'lwlKaData:v1', TTL = 30 * 60 * 1000, pending = null;
	function load() {
		if (pending) return pending;
		try {
			var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
			if (c && Date.now() - c.t < TTL) { pending = Promise.resolve(build(c.d)); return pending; }
		} catch (e) {}
		var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
		var th = window.Shopify && Shopify.theme;
		var pv = th && th.role && th.role !== 'main' ? '&preview_theme_id=' + th.id : '';
		pending = fetch(root + '?section_id=lwl-kombin-veri' + pv, { headers: { Accept: 'text/html' } })
			.then(function (r) { return r.text(); })
			.then(function (html) {
				var m = html.match(/<script type="application\/json" class="js-ka-data">([\s\S]*?)<\/script>/);
				var d = m ? m[1] : '[]';
				try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
				return build(d);
			});
		pending.catch(function () { pending = null; });
		return pending;
	}
	window.LWLKombin = { load: load };
})();
